import React, { useEffect, useMemo } from "react";
import ContainerBackgroundWrapper from "../components/Backgrounds"
import LogoCenter from "../components/LogoCenter"
import { Apis } from "../util/Apis"
import CustomLoading from "../components/CustomLoading"
import Text from "../styledComponents/TextStyled"
import NoSorteos from "../components/NoSorteos";
import { useParams } from "react-router";
import useGet from "../hooks/useGet";
import useHideNames from "../hooks/useHideNames";
import { maskName } from "../util/privacy";
import ParticipantTicker from "../components/ParticipantTicker";
import {
  ParticipantsLayout, StatsColumn, StatCard, StatNumber, StatLabel,
  PrivacyButton, ParticipantTable, ParticipantHeader, ParticipantRow,
} from "./SorteoParticipants.styles";

const SorteoParticipants = () => {
  const { id } = useParams()
  const [hideNames, toggleHideNames] = useHideNames()

  const { loading, data, fetchData } = useGet({
    url: Apis.SORTEOS + `/sorteos/${id}/participantes/v2`,
    initialValue: [],
  })

  useEffect(() => {
    const interval = setInterval(() => {
      fetchData({}, { showLoading: false })
    }, 5000)

    return () => clearInterval(interval)
  }, [fetchData])

  const totalCupones = useMemo(() => {
    const total = data.reduce((a, b) => a + b.quantity, 0)
    const numberFormatter = Intl.NumberFormat('en-US');
    return numberFormatter.format(total);
  }, [data])

  return (
    <ContainerBackgroundWrapper>
      {!loading ?
        <>
          <LogoCenter mainview={true} />
          {data.length === 0 ?
            <NoSorteos>
              <Text textStyle='small'>Este sorteo aún no tiene participantes</Text>
            </NoSorteos>
            :
            <ParticipantsLayout data-testid="participants-layout">
              <StatsColumn>
                <StatCard aria-label="Total de participantes">
                  <StatNumber>{data.length}</StatNumber>
                  <StatLabel>PARTICIPANTES</StatLabel>
                  <PrivacyButton variant="outline"
                    aria-pressed={hideNames}
                    onClick={toggleHideNames}
                  >
                    {hideNames ? 'Mostrar nombres' : 'Ocultar nombres'}
                  </PrivacyButton>
                </StatCard>
                <StatCard aria-label="Total de cupones depositados">
                  <StatNumber>{totalCupones}</StatNumber>
                  <StatLabel>CUPONES DEPOSITADOS</StatLabel>
                </StatCard>
              </StatsColumn>
              <ParticipantTable aria-label="Lista de participantes">
                <ParticipantHeader>
                  <span>JUGADOR</span>
                  <span>CUPONES</span>
                </ParticipantHeader>
                <ParticipantTicker
                  items={data}
                  getKey={item => item.customerId}
                  renderRow={item => (
                    <ParticipantRow>
                      <span className="participant-name">
                        {maskName(item.firstName, item.lastName1, hideNames)}
                      </span>
                      <span className="participant-coupons">{item.quantity}</span>
                    </ParticipantRow>
                  )}
                />
              </ParticipantTable>
            </ParticipantsLayout>
          }
        </>
        :
        <CustomLoading />
      }
    </ContainerBackgroundWrapper>
  )
}

export default SorteoParticipants;
